// =============================================================================
// MeuDriver — MaintenanceBanner (Batch V4)
// Exibe banner fixo no topo quando maintenance_mode = 'true'.
// Não aparece em rotas /admin/*.
// O fechamento é persistido por sessão via localStorage.
// =============================================================================

import { useState } from 'react'
import { AlertTriangle, X } from 'lucide-react'
import { useLocation } from 'react-router-dom'
import { usePlatformSetting } from '@/hooks/usePlatformSettings'

export function MaintenanceBanner() {
  const location = useLocation()

  const { data: modeRow } = usePlatformSetting('maintenance_mode')
  const { data: msgRow } = usePlatformSetting('maintenance_message')

  const isActive = modeRow?.value === 'true'
  const message = msgRow?.value ?? 'Estamos em manutenção programada. Voltamos em breve!'

  // Chave única por sessão — se o valor mudar, o banner reaparece
  const dismissKey = `maintenance_dismissed_${modeRow?.value ?? 'false'}`
  const [dismissed, setDismissed] = useState(() => {
    try {
      return localStorage.getItem(dismissKey) === 'true'
    } catch {
      return false
    }
  })

  // Não renderizar em rotas admin
  if (location.pathname.startsWith('/admin')) return null

  // Não renderizar se desativado ou fechado
  if (!isActive || dismissed) return null

  function handleDismiss() {
    try {
      localStorage.setItem(dismissKey, 'true')
    } catch {
      // ignora erros de storage
    }
    setDismissed(true)
  }

  return (
    <div
      role="alert"
      className="relative flex items-center gap-3 bg-red-600 px-4 py-3 text-white"
      data-testid="maintenance-banner"
    >
      <AlertTriangle className="h-4 w-4 shrink-0" aria-hidden="true" />
      <p className="flex-1 text-sm font-medium text-center">{message}</p>
      <button
        onClick={handleDismiss}
        className="shrink-0 rounded-md p-0.5 hover:bg-white/20 transition-colors"
        aria-label="Fechar banner de manutenção"
        data-testid="maintenance-banner-close"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  )
}
